import React from 'react';
import './CommonSwitch.scss';
import PropTypes from 'prop-types';

const CommonSwitch = (props = {}) => {
    const { id = 1, checked = false, handleClick, disabled = false } = props;
    const disabledClass = disabled ? 'disabled' : '';
    return (
        <label className={`switch ${disabledClass}`} htmlFor={`Status-${id}`} aria-label="Toggle status">
            <input
                onChange={() => {}}
                className={checked ? 'active' : ''}
                type="checkbox"
                id={`Status-${id}`}
                checked={checked}
                disabled={disabled}
            />
            <span className="slider round"></span>
            <label
                htmlFor={`Status-${id}`}
                onClick={e => {
                    if (!disabled && handleClick) handleClick(e);
                }}
                onKeyDown={e => {
                    if (disabled) return;
                    if ((e.key === 'Enter' || e.key === ' ') && handleClick) handleClick(e);
                }}
                role="button"
                tabIndex={disabled ? -1 : 0}
                className={`overlay-click ${disabledClass}`}
                aria-label="Toggle switch"
                aria-disabled={disabled}
            ></label>
        </label>
    );
};

export default CommonSwitch;

CommonSwitch.propTypes = {
    id: PropTypes.string,
    checked: PropTypes.bool,
    handleClick: PropTypes.func,
};
